import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { FaqImportExportState, SLICE_NAME } from './models';

const faqImportExportSelector = (state: RootState): FaqImportExportState => state[SLICE_NAME];

export const selectFaqImportFile = createSelector(
  faqImportExportSelector,
  (state: FaqImportExportState) => state.selectedFile,
);

export const selectFaqImportPreview = createSelector(
  faqImportExportSelector,
  (state: FaqImportExportState) => state.preview,
);

export const selectIsPreviewingFaqImport = createSelector(
  faqImportExportSelector,
  (state: FaqImportExportState) => state.isPreviewing,
);

export const selectIsApplyingFaqImport = createSelector(
  faqImportExportSelector,
  (state: FaqImportExportState) => state.isApplying,
);

export const selectIsExportingFaqs = createSelector(
  faqImportExportSelector,
  (state: FaqImportExportState) => state.isExporting,
);
